import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';

@Component({
    standalone: false,
  selector: 'confirm-component',
  templateUrl: 'confirm.component.html'
})

export class ConfirmComponent {
  isChecked: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
  }

  onClose(): void {
    this.dialogRef.close(this.isChecked);
  }
}
